export default "__VITE_ASSET__5e299f78__"